export enum ServiceLevel {
    SINGLE_PLAY = 1,
    DOUBLE_PLAY = 2,
    TRIPLE_PLAY = 3,
}
